import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import isBetween from 'dayjs/plugin/isBetween';
import relativeTime from 'dayjs/plugin/relativeTime';

// Extend dayjs with plugins
dayjs.extend(utc);
dayjs.extend(isBetween);
dayjs.extend(relativeTime);

// Configure dayjs locale
dayjs.locale('en');

// Common date formatting functions
export const formatDate = (
  date: string | Date,
  format: string = 'YYYY-MM-DD'
): string => {
  return dayjs(date).format(format);
};

export const formatDateTime = (
  date: string | Date,
  format: string = 'YYYY-MM-DD HH:mm:ss'
): string => {
  return dayjs(date).format(format);
};

export const formatRelativeTime = (date: string | Date): string => {
  return dayjs(date).fromNow();
};

export const formatDateForDisplay = (date: string | Date): string => {
  return dayjs(date).format('MMM DD, YYYY');
};

export const formatTimeForDisplay = (date: string | Date): string => {
  return dayjs(date).format('HH:mm');
};

export const formatDateTimeForDisplay = (date: string | Date): string => {
  return dayjs(date).format('MMM DD, YYYY HH:mm');
};

// Date manipulation functions
export const addDays = (date: string | Date, days: number): Date => {
  return dayjs(date).add(days, 'days').toDate();
};

export const subtractDays = (date: string | Date, days: number): Date => {
  return dayjs(date).subtract(days, 'days').toDate();
};

export const startOfDay = (date: string | Date): Date => {
  return dayjs(date).startOf('day').toDate();
};

export const endOfDay = (date: string | Date): Date => {
  return dayjs(date).endOf('day').toDate();
};

// Validation functions
export const isValidDate = (date: string | Date): boolean => {
  return dayjs(date).isValid();
};

export const isToday = (date: string | Date): boolean => {
  return dayjs(date).isSame(dayjs(), 'day');
};

export const isYesterday = (date: string | Date): boolean => {
  return dayjs(date).isSame(dayjs().subtract(1, 'day'), 'day');
};

export const isThisWeek = (date: string | Date): boolean => {
  return dayjs(date).isSame(dayjs(), 'week');
};

export const isThisMonth = (date: string | Date): boolean => {
  return dayjs(date).isSame(dayjs(), 'month');
};

export const isThisYear = (date: string | Date): boolean => {
  return dayjs(date).isSame(dayjs(), 'year');
};

// Export dayjs for direct use when needed
export { dayjs };
